import Vue from "vue";
import cAddress from "./app.vue";
import Vuex from "vuex";

Vue.use(Vuex);
export const store = new Vuex.Store({
  state: {
    customerId: "",
    cardPlaceholder: "",
    isLoading: true,
    allCards: null,
    step: 0
  },
  getters: {
    getCustomerId: (state) => state.customerId,
    getCardPlaceholder: (state) => state.cardPlaceholder,
    getLoading: (state) => state.isLoading,
    getAllCards: (state) => state.allCards,
    getStep: (state) => state.step
  },
  mutations: {
    setCardPlaceholder(state, cardholder) {
      state.cardPlaceholder = cardholder;
    },
    setCustomerId(state, customerId) {
      state.customerId = customerId;
    },
    setLoading(state, status) {
      state.isLoading = status;
    },
    setAllCards(state, cards) {
      state.allCards = cards;
    },
    setStep(state, num) {
      state.step = num;
    }
  },
  actions: {
    setCardPlaceholder({ commit }, cardholder) {
      commit("setCardPlaceholder", cardholder);
    },
    setCustomerId({ commit }, customerId) {
      commit("setCustomerId", customerId);
    },
    setLoading({ commit }, status) {
      commit("setLoading", status);
    },
    setAllCards({ commit }, cards) {
      commit("setAllCards", cards);
    },
    setStep({ commit }, num) {
      commit("setStep", num);
    }
  },
  modules: {}
});

new Vue({ store, render: (h) => h(cAddress) }).$mount("#app-address");
